interface StatusBarProps {
  statementCount: number;
  maxDepth: number;
  linkCount: number;
  mode: string;
  onHelpToggle: () => void;
}

export function StatusBar({
  statementCount,
  maxDepth,
  linkCount,
  mode,
  onHelpToggle,
}: StatusBarProps) {
  return (
    <div className="status-bar">
      <span>
        Statements: {statementCount} &nbsp;|&nbsp; Depth: {maxDepth}{" "}
        &nbsp;|&nbsp; Links: {linkCount}
      </span>
      <span style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
        <span style={{ textTransform: "uppercase" }}>{mode}</span>
        <button className="help-btn" onClick={onHelpToggle} title="Help (?)">
          ?
        </button>
      </span>
    </div>
  );
}
